module.exports = __webpack_public_path__ + "img/DJI.4223c086.svg";